import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { LOCATIONS } from "@/data/content";
import { Reveal, SectionLabel } from "./Reveal";

export const Locations = () => (
  <section id="locations" data-testid="locations-section" className="relative py-24 md:py-32 bg-[#0E101D]">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <Reveal>
        <SectionLabel>Find us</SectionLabel>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">Pull up<br /><span className="text-stroke">near you.</span></h2>
      </Reveal>
      <div className="mt-14 grid md:grid-cols-3 gap-5">
        {LOCATIONS.map((l, i) => (
          <Reveal key={l.id} delay={i * 0.08}>
            <div data-testid={`location-card-${l.id}`} className="h-full rounded-[26px] border border-white/10 bg-[#131627] p-7 hover:border-[#FFEF00]/60 transition-colors">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FFEF00]">{l.city}</p>
              <h3 className="mt-3 font-display font-extrabold text-xl">{l.name}</h3>
              <div className="mt-6 space-y-3 text-sm text-slate-300">
                <p className="flex gap-3"><MapPin size={16} className="text-[#14C3F7] shrink-0 mt-0.5" />{l.address}</p>
                {l.phone.startsWith("[") ? <p className="flex gap-3"><Phone size={16} className="text-[#14C3F7] shrink-0 mt-0.5" />{l.phone}</p> : <a href={`tel:${l.phone.startsWith("+") ? l.phone.replace(/[^\d+]/g, "") : "+91" + l.phone.replace(/\D/g, "")}`} data-testid={`location-phone-${l.id}`} className="flex gap-3 hover:text-[#FFEF00]"><Phone size={16} className="text-[#14C3F7] shrink-0 mt-0.5" />{l.phone}</a>}
                {l.email && <a href={`mailto:${l.email}`} className="flex gap-3 hover:text-[#FFEF00]"><Mail size={16} className="text-[#14C3F7] shrink-0 mt-0.5" />{l.email}</a>}
                <p className="flex gap-3"><Clock size={16} className="text-[#14C3F7] shrink-0 mt-0.5" />{l.hours}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
